import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "CloudOff";
const CloudOff = memo(themed(Icon));
export {
  CloudOff
};
//# sourceMappingURL=cloud-off.js.map
